<template>
    <div :class="{'mobile-menu-subgroup':true, 'selected':selected, 'open':open}" ref="root">
        <a class="mobile-menu-subgroup-header" href="#" @click="expand">
            <img v-if="icon" :src="icon" />{{ name }}
        </a>
        <div class="mobile-menu-items" v-show="open">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: ["name", "icon",],
    components: {
    },
    data() {
        return {
            open: false,
            selected: false,
        };
    },
    mounted() {
        this.refresh();
        window.addEventListener('mobile-menu-recalc-subgroup', this.refresh);
    },
    unmounted() {
        window.removeEventListener('mobile-menu-recalc-subgroup', this.refresh);
    },
    methods: {
        expand() {
            this.open = !this.open;
        },        
        refresh() {
            const element = this.$refs.root;
            if (element) {
                this.selected = element.querySelector('.mobile-menu-item.selected') !== null;
                if (this.selected) {
                    this.open = true;
                }
            }
        },
    }
}
</script>

<i18n>
{
    en: {
    },
    ru: {
    }
}
</i18n>

<style lang="scss" scoped>
.open {
    .mobile-menu-subgroup-header::after {
        transform: rotate(0deg);
        //transition: transform 0.3s ease;
    }
}
.mobile-menu-subgroup, .mobile-menu-subgroup-header {
    a {
        img {
            width: 16px;
            margin-left: 16px;
            margin-right: 8px;
        }   
    }
}
.mobile-menu-subgroup {
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-bottom: solid 1px #ebebeb;
    /*&.selected {
        a {
            background: darkcyan;
            color: white;
        }
    }*/
    img {
        position: relative;
        bottom: 2px;
        width: 24px;
        margin-left: 16px;
        margin-right: 8px;
    }
}

.mobile-menu-subgroup-header {
    color: #212529;
    text-decoration: none;
    font-size: 1.0em;
    position: relative;
    min-height: 48px;
    align-content: center;
}
.mobile-menu-subgroup-header::after {
    display: inline-block;
    content: "";
    background-image: url(/static/images/redisign/new-game-catalog/chevron-down.svg);
    width: 10px;
    height: 8px;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    position: absolute;
    right: 16px;
    top: 1px;
    transform: rotate(270deg);
    opacity: 0.6;
}

.mobile-menu-items {
    display: flex;
    flex-direction: column;
    //margin-left: 16px;
    padding-bottom: 16px;
    gap: 8px;
}

</style>